import styled, { css } from 'styled-components';
import { mr } from 'styled-components-spacing';

export const Input = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  border-radius: 2px;

  ${({ theme }) =>
    theme &&
    css`
      background-color: ${theme.colors.gray[200]};
      /* An empty box reads as a box rather than as a grey smudge, which is what
         tells a reader that the ticked ones next to it were a choice. */
      border: 1px solid ${theme.colors.gray[300]};

      svg {
        width: 10px;
        height: 9px;

        fill: ${theme.colors.white};
      }
    `}

  ${({ theme, selected }) =>
    theme &&
    selected &&
    css`
      /* Raised above the disabled rule of the button below, which paints every
         box grey: a disabled checkbox still has to show what was ticked, which
         is what a read only form is for. */
      &&& {
        background-color: ${theme.colors.secondary};
        border-color: ${theme.colors.secondaries.darker};
      }
    `}
`;

export default styled.button`
  display: flex;
  text-align: left;
  cursor: pointer;

  ${({ theme }) =>
    theme &&
    css`
      font-size: ${theme.font.size.pixel('14')};
      font-weight: ${theme.font.weight.regular};
      color: ${theme.colors.gray[500]};

      ${Input} {
        ${mr(8)}
      }
    `}

  ${({ theme, disabled }) =>
    theme &&
    disabled &&
    css`
      cursor: not-allowed;
      /* The label stays readable: a read only form is meant to be read. */
      color: ${theme.colors.gray[600]};

      ${Input} {
        background-color: ${theme.colors.gray[300]};
      }
    `}

  line-height: 16px;
`;
